import styled from 'styled-components';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTermsDetailQuery } from 'src/hooks/queries/useTermsDetailQuery';
import { termsCss } from 'src/styles/termsCss';
import { TelecomType } from 'src/types/type';

const TermWrap = styled.div`
  ${termsCss}
`;

const TermsPopup = () => {
  const { requestID, telecom, termsOrderIdx } = useParams();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const getTermsDetail = useTermsDetailQuery(`${requestID}`, {
    Telecom: Number(telecom) as TelecomType,
    Idx: Number(termsOrderIdx)
  });

  useEffect(() => {
    const data = getTermsDetail.data;
    if (!!data) {
      !!data.TermsTitle && setTitle(data.TermsTitle);
      !!data.TermsContents && setContent(data.TermsContents);
    }
  }, [getTermsDetail, setTitle, setContent])

  return (
    <TermWrap>
      <div className="wrapper page_index">
        <div className="containerPop">
          <div className="bg_sub"></div>

          <div className="inner w1000 padding">
            <div className="box_content">
              <h2 className="h2_01">{title}</h2>
              <div className="terms-cover" dangerouslySetInnerHTML={{ __html: content?.split('\n').join('<br />') }}></div>
            </div>
          </div>
        </div>
      </div>

      <div className="dimmed"></div>
    </TermWrap>
  );
};

export default TermsPopup;
